import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import s from './Button.module.css';

function Button(props) {
  const { children, className, size, isSquared, isOpacity, onClick } = props;
  return (
    <button
      onClick={onClick}
      className={cn(
        s.button,
        s[size],
        isSquared ? s.squared : '',
        isOpacity ? s.opacity : '',
        className,
      )}
    >
      {children}
    </button>
  );
}

export default Button;

Button.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'big']),
  isSquared: PropTypes.bool,
  isOpacity: PropTypes.bool,
  onClick: PropTypes.func,
};
